import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 登录
 * @user: antes
 * @emial: tangzhlyd@gmail.com
 * @data: 2020/12/8 下午3:39
 */ import $styles from "./index.scss";
import logo from "@/assets/logo-white.png";
import headicon from "@/assets/headicon.png";
import { Button, Checkbox, Form, Input, message } from "antd";
import { useRequest, useSetStore } from "@/hooks";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import pwdicon from "@/assets/pwdicon.png";
import { isNil } from "ramda";
import { encrypt, decrypt, getEnv } from "@/utils";
import { getSocket } from "@/utils/socket";
import { useEffect, useState } from "react";
import { Loading } from "@/components/Loading";
import { LoginInfoState } from "@/store/globalStore";
import globalConst from "@/utils/global";
function Login() {
    const setLoginInfo = useSetStore(LoginInfoState);
    useState(()=>{
        localStorage.removeItem("rantion-erp-accessToken");
        return null;
    });
    const isOss = getEnv("SSO") && process.env.ENVIRONMENT !== "development";
    const navigate = useNavigate();
    const location = useLocation();
    const [params] = useSearchParams();
    useEffect(()=>{
        if (isOss) {
            const ticket = params.get("code");
            let state = params.get("state") ?? "";
            if (state && state !== "/account") {
                state = atob(state);
            } else {
                state = "/account";
            }
            if (ticket) {
                API.ucenter.iamCallback.login.request({
                    code: ticket,
                    clientId: globalConst.iamClientId ?? ""
                }, {
                    noToken: true
                }).then((param)=>{
                    let { data, success } = param;
                    if (data && success && data.accessToken) {
                        setLoginInfo(()=>{
                            return {
                                accessToken: data.accessToken,
                                userNo: ""
                            };
                        });
                        navigate(state.includes("login") ? "/account" : state);
                    } else {
                        message.error("操作异常、无法获取到Token，请联系管理员");
                    }
                });
            } else {
                const redirect_uri = params.get("redirect_uri");
                const redirect = params.get("redirect") ?? "/account";
                const callBackUrl = redirect_uri ? redirect_uri : redirect;
                const _redirect_uri = `${window.location.origin}/login?state=${btoa(callBackUrl.includes("login") ? "/account" : decodeURIComponent(callBackUrl))}`;
                window.location.href = `${globalConst.signInUrl}&redirect_uri=${encodeURIComponent(_redirect_uri)}`;
            }
        }
    }, [
        location,
        navigate,
        params,
        setLoginInfo,
        isOss
    ]);
    const { run, loading } = useRequest(API.ucenter.sysUserLogin.login.request, {
        manual: true,
        onSuccess: function(param) {
            let { data, success } = param;
            if (success && !isNil(data)) {
                setLoginInfo(()=>{
                    return {
                        accessToken: data.accessToken,
                        userNo: data.userNo
                    };
                });
                getSocket();
                const redirect_uri = params.get("redirect_uri") ?? "/account";
                navigate(redirect_uri.includes("login") ? "/account" : redirect_uri);
            }
        }
    });
    if (isOss) {
        return /*#__PURE__*/ _jsx(Loading, {});
    }
    function onFinish(value) {
        const formValue = {
            password: value.password,
            userName: value.userName
        };
        run(formValue);
        value.userName = encrypt(value.userName, 123, 25);
        value.password = encrypt(value.password, 123, 25);
        value.decrypt = true;
        value.remember && localStorage.setItem("loginIinformation", JSON.stringify(value));
    }
    const str = localStorage.getItem("loginIinformation");
    const loginIinformation = str ? JSON.parse(str) : {};
    if (loginIinformation.decrypt) {
        loginIinformation.userName = decrypt(loginIinformation.userName, 123, 25);
        loginIinformation.password = decrypt(loginIinformation.password, 123, 25);
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: $styles.bgc,
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: logo,
                className: $styles.logo
            }),
            /*#__PURE__*/ _jsx("div", {
                className: $styles.card,
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: $styles.head,
                            children: "用户登录"
                        }),
                        /*#__PURE__*/ _jsxs(Form, {
                            onFinish: onFinish,
                            initialValues: loginIinformation,
                            children: [
                                /*#__PURE__*/ _jsx(Form.Item, {
                                    name: "userName",
                                    rules: [
                                        {
                                            required: true,
                                            message: "请输入手机号/邮箱"
                                        }
                                    ],
                                    children: /*#__PURE__*/ _jsx(Input, {
                                        suffix: /*#__PURE__*/ _jsx("i", {
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: headicon,
                                                className: $styles.icon
                                            })
                                        }),
                                        size: "large",
                                        placeholder: "请输入手机号/邮箱"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Form.Item, {
                                    name: "password",
                                    rules: [
                                        {
                                            required: true,
                                            message: "请输入密码!"
                                        }
                                    ],
                                    children: /*#__PURE__*/ _jsx(Input, {
                                        suffix: /*#__PURE__*/ _jsx("i", {
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: pwdicon,
                                                className: $styles.icon
                                            })
                                        }),
                                        size: "large",
                                        type: "password",
                                        placeholder: "请输入密码（初始密码为：000000）"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(Form.Item, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Item, {
                                            name: "remember",
                                            valuePropName: "checked",
                                            noStyle: true,
                                            children: /*#__PURE__*/ _jsx(Checkbox, {
                                                children: "记住密码"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Link, {
                                            to: "/register",
                                            className: $styles.forgot,
                                            children: "忘记密码？"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Item, {
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        type: "primary",
                                        loading: loading,
                                        htmlType: "submit",
                                        className: $styles.loginbtn,
                                        children: "登陆"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
export default Login;
